<template lang="pug">
  .b-history
    ._fetch-more(v-if="!allFetched")
      Btn(@click="fetchAllHistory" grey transparent sm) Загрузить всю историю
        Icon(name="angle-right")
    FormBlock._block(v-if="history.length" mobile)
      template(v-for="item in history")
        TaskDetailHistoryBlock._history-block(v-if="Array.isArray(item)" :items="item" :key="item[0].id")
        ._item(v-if="item.type === 'comment'" :key="item.id")
          CommentForm(
            v-if="editableComment && editableComment.id === item.id"
            :comment="editableComment"
            @cancel="cancelCommentUpdate"
            @submit="updatePublishedComment"
            @scrollToComment="scrollToComment"
          )
            template(#files)
              ProjectFileUploader(:selected="editableComment.projectFiles" @select="onPublishedCommentFilesUpdate")
          CommentTile(
            v-else
            :comment="item"
            :ref="item['@id']"
            :editable="allowToEditComments"
            @edit="editPublishedComment(item)"
            @reply="$emit('reply', item)"
            @delete="deleteComment(item)"
            @scrollToComment="scrollToComment"
          )
</template>

<script>
import FormBlock from '@/components/FormBlock.vue';
import CommentForm from '@/components/CommentForm.vue';
import CommentTile from '@/components/CommentTile.vue';
import TaskDetailHistoryBlock from '@/components/task/detail/TaskDetailHistoryBlock.vue';
import ProjectFileUploader from '@/components/ProjectFileUploader.vue';

import taskChangeApi from '@/api/taskChange';

export default {
  name: 'TaskDetailHistory',
  components: { TaskDetailHistoryBlock, FormBlock, CommentTile, CommentForm, ProjectFileUploader }, // eslint-disable-line
  props: {
    allowToEditComments: Boolean,
    project: Object,
    task: Object,
  },
  data() {
    return {
      items: [],
      allFetched: false,
      editableComment: null,
    };
  },
  async created() {
    this.loadFirstComments();
  },
  watch: {
    $route(val) {
      this.$nextTick(() => { this.scrollToComment(`/api/task_changes/${val.query.comment}`); });
    },
  },
  computed: {
    ids() {
      return this.items.map(i => i.id);
    },
    history() {
      return this.items
        .map((item) => ({ ...item, createdAt: new Date(item.createdAt) }))
        .sort((a, b) => a.createdAt - b.createdAt)
        .reduce((acc, item) => {
          if (item.type === 'comment') {
            return [...acc, item];
          }

          if (acc.length <= 0) {
            return [[item]];
          }

          const last = acc.pop();
          return Array.isArray(last)
            ? [...acc, [...last, item]]
            : [...acc, last, [item]];
        }, []);
    },
  },
  methods: {
    async loadFirstComments() {
      const filter = {
        task: this.task.id,
        itemsPerPage: 5,
        type: 'comment',
        isDraft: false,
      };

      const r = await taskChangeApi.fetchList(filter, true);
      this.addNewItems(r.items);
      this.loadFirstHistory();

      const commentId = this.$route.query?.comment;

      if (!commentId) return;

      const commentFetched = this.items.find(i => i.id === +commentId);
      if (commentFetched) {
        this.$nextTick(() => { this.scrollToComment(`/api/task_changes/${commentId}`); });
      } else {
        this.fetchAllHistory(commentId);
      }
    },
    async loadFirstHistory() {
      const date = this.items.slice(-1).pop()?.createdAt;

      const defaultFilter = { task: this.task.id, isDraft: false };
      const filter = date
        ? { ...defaultFilter, pagination: false, 'createdAt[after]': date }
        : { ...defaultFilter, itemsPerPage: 10 };

      const r = await taskChangeApi.fetchList(filter, true);
      this.addNewItems(r.items);
      this.fetchNewChanges();
    },
    async fetchAllHistory(commentId) {
      const filter = {
        task: this.task.id,
        pagination: false,
        isDraft: false,
      };

      const r = await taskChangeApi.fetchList(filter, true);
      this.allFetched = true;
      this.items = r.items;

      if (commentId) {
        this.$nextTick(() => { this.scrollToComment(`/api/task_changes/${commentId}`); });
      }
    },
    fetchNewChanges() {
      const loadChanges = () => {
        if (document.hidden) return;
        taskChangeApi
          .fetchList({ task: this.task.id, itemsPerPage: 5, isDraft: false })
          .then((r) => { this.addNewItems(r.items); });
      };

      setInterval(loadChanges, 10000);
    },
    addNewItems(arr) {
      const newItems = arr.filter(i => !this.ids.includes(i.id));
      if (newItems.length) {
        this.items = [...this.items, ...newItems];
      }
    },
    extAdd(item) {
      this.items.push(item);
    },
    restoreProjectFiles(projectFiles) {
      const filesInStore = this.$store.state.projectFile.files[this.project.id];
      return projectFiles
        .map((iri) => filesInStore.find((file) => file['@id'] === iri))
        .map((item) => ({ ...item, state: 'static' }));
    },
    scrollToComment(ref) {
      this.$refs[ref]?.[0]?.$el?.scrollIntoView({ behavior: 'smooth' }); // eslint-disable-line no-unused-expressions
    },
    async deleteComment(comment) {
      if (await this.$confirm('Вы действительно хотите удалить комментарий?')) {
        taskChangeApi.delete(comment.id, true)
          .then(() => { this.items = this.items.filter((item) => item.id !== comment.id); })
          .catch(() => { this.$alert('При удалении произошла ошибка'); });
      }
    },

    editPublishedComment(comment) {
      this.editableComment = comment;
      this.editableComment.projectFiles = comment.projectFiles.map((item) => item['@id']);
      this.$store.commit('closePrevent/enable');

      // this.editableComment = {
      //   ...comment,
      //   projectFiles: comment.projectFiles.map((item) => item['@id']),
      // };
    },
    onPublishedCommentFilesUpdate(files) {
      this.editableComment.projectFiles = files;
    },
    updatePublishedComment({ id, info: { text } }) {
      const { projectFiles } = this.editableComment;
      const editableCommentBkp = this.editableComment;

      // this.projectFiles.filter((i) => i) ?? [], // wtf
      // todo replyTo ?

      // const commentInHistory = this.history.find((item) => item.id === id);
      // commentInHistory.info.text = text;
      // commentInHistory.projectFiles = this.restoreProjectFiles(projectFiles);

      taskChangeApi.update(id, { text, projectFiles }, true)
        .then((r) => {
          this.editableComment.info.text = text;
          this.editableComment.projectFiles = this.restoreProjectFiles(projectFiles);
          this.editableComment.updatedAt = r.updatedAt;
          this.editableComment = null;
          this.$store.commit('closePrevent/disable');
        })
        .catch(() => {
          this.$alert('При сохранении произошла ошибка');
          this.editableComment = editableCommentBkp;
          this.editableComment.projectFiles = projectFiles;
        });
    },
    cancelCommentUpdate() {
      this.editableComment.projectFiles = this.restoreProjectFiles(this.editableComment.projectFiles);
      this.editableComment = null;
      this.$store.commit('closePrevent/disable');
    },
  },
};
</script>

<style scoped lang="scss">
.history {
  &__block {
    display: flex;
    flex-direction: column;
    gap: 40px;
    margin-bottom: 30px;
  }

  &__history-block {
     margin: -20px 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__fetch-more {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 30px;

    ::v-deep .button.transparent {
      border-color: #D1D9F0 !important;
    }
    svg {
      fill: #8B8CA9;
    }

    &:before, &:after {
      display: block;
      content: '';
      height: 1px;
      background: #D1D9F0;
      flex-grow: 1;
    }
  }
}
</style>
